/**
 * SR3-2: one structured line per call page action, so a UI action, its
 * request and the parallelCallId can be matched in the logs. Allowlisted
 * fields only: never a note, a transcript, a name or a phone number.
 */
const ALLOWED = ['action', 'correlationId', 'parallelCallId', 'outcome', 'status', 'code', 'attempt', 'revision'] as const;
type Field = (typeof ALLOWED)[number];

export function callPageLogPayload(fields: Record<string, unknown>): Partial<Record<Field, string | number>> {
  const out: Partial<Record<Field, string | number>> = {};
  for (const key of ALLOWED) {
    const v = fields[key];
    if (typeof v === 'string' || typeof v === 'number') out[key] = v;
  }
  return out;
}

export function logCallPage(fields: Record<string, unknown>): void {
  // eslint-disable-next-line no-console
  console.info('[call_page]', JSON.stringify(callPageLogPayload(fields)));
}

export function newCorrelationId(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c?.randomUUID) return c.randomUUID();
  return `q-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
